import script from "./seo-header.vue?vue&type=script&lang=js"
export * from "./seo-header.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__